import { render, staticRenderFns } from "./SituationPerOrganization.vue?vue&type=template&id=1c39fd94&scoped=true&"
import script from "./SituationPerOrganization.vue?vue&type=script&lang=js&"
export * from "./SituationPerOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39fd94",
  null
  
)

export default component.exports